<section class="section alt text-left py-20">
  <div class="container mx-auto px-4">
    <div class="mb-16 text-center">
      <h2 class="text-3xl md:text-4xl font-bold mb-6">
        Nos Standards d'Excellence Technique <span class="text-[var(--brand)]">2026</span>
      </h2>
      <p class="text-[var(--muted)] max-w-2xl mx-auto text-lg">
        Nous déployons les meilleures pratiques d'architecture moderne (quelle que soit la stack) pour garantir performance, scalabilité et maintenabilité de vos systèmes critiques.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div 
        *ngFor="let pillar of pillars" 
        class="card bg-[var(--card)] border border-[var(--border)] rounded-[var(--radius)] p-8 hover:shadow-[var(--shadow)] transition-all duration-300 hover:-translate-y-1 flex flex-col h-full"
      >
        <div class="w-12 h-12 mb-6 text-[var(--brand)] flex items-center justify-center bg-[var(--brand)]/10 rounded-lg" [innerHTML]="getSafeHtml(pillar.icon)">
        </div>
        <h3 class="text-xl font-bold mb-4 text-[var(--text)]">
          {{ pillar.title }}
        </h3>
        <p class="text-[var(--text-light)] leading-relaxed text-sm md:text-base flex-grow">
          {{ pillar.content }}
        </p>
      </div>
    </div>
  </div>
</section>